import { authFetch } from './apiClient';

export async function generateNmDocument(quoteId, documentType, delaySeconds = 0) {
    if (!quoteId) return;

    const response = await authFetch('api/Document/GenerateNmDocument', {
        method: 'POST',
        body: JSON.stringify({
            QuoteId: quoteId,
            DocumentType: documentType,
            DelaySeconds: delaySeconds,
        }),
    });

    if(!response.ok) {
        throw new Error(`GenerateNmDocument (${documentType}) failed: ${response.status}`);
    }

    return response.json();
}

export async function generateDes(quoteId) {
    if (!quoteId) return;

    const response = await authFetch(`api/Document/GenerateDes/${quoteId}`, {
        method: 'POST',
    });

    if (!response.ok) {
        throw new Error(`GenerateDes failed: ${response.status}`);
    }

    return response.json();
}

export async function uploadAdminDocument(quoteId, documentType, file) {
    if (!quoteId || !documentType || !file) {
        throw new Error('QuoteId, document type, and file are required.');
    }

    const formData = new FormData();
    formData.append('QuoteId', quoteId);
    formData.append('DocumentType', documentType);
    formData.append('File', file);

    const response = await authFetch('api/Document/UploadAdminDocument', {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        let message = `UploadAdminDocument failed: ${response.status}`;
        try {
            const body = await response.json();
            message = body.errorMessage || body.error_message || message;
        } catch {
            // Keep fallback message when body is not JSON.
        }
        throw new Error(message);
    }

    return response.json();
}